import { useState } from "react";
import { toast } from "sonner";
import { TextField, TextArea, SelectField } from "./fields";
import { submitStaffing } from "../../lib/api";

const ENGAGEMENTS = [
  "Contract Staffing",
  "Contract-to-Hire",
  "Direct Hire",
  "Engineering Staffing",
  "Dedicated Team",
  "Offshore Development Team",
];

const INDUSTRIES = [
  "Healthcare & Life Sciences",
  "Banking & Financial Services",
  "Manufacturing & Industrial",
  "Semiconductor & Electronics",
  "Engineering & Technology",
  "Logistics & Supply Chain",
  "Automotive & Mobility",
  "Energy & Utilities",
  "Telecommunications",
  "Retail & E-Commerce",
  "Government & Public Sector",
  "Other",
];

const initial = {
  company: "", contact_name: "", email: "", phone: "",
  engagement_type: "", industry: "", roles_needed: "", details: "",
};

export function StaffingForm({ onDone }) {
  const [form, setForm] = useState(initial);
  const [loading, setLoading] = useState(false);
  const set = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await submitStaffing(form);
      toast.success("Requirement received", {
        description: "Our talent team will reach out to you shortly.",
      });
      setForm(initial);
      onDone && onDone();
    } catch (err) {
      toast.error("Something went wrong", { description: "Please try again." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="mt-2 space-y-4" data-testid="staffing-form">
      <div className="grid gap-4 sm:grid-cols-2">
        <TextField label="Company" name="company" required value={form.company} onChange={set} testId="staffing-company" />
        <TextField label="Your Name" name="contact_name" required value={form.contact_name} onChange={set} testId="staffing-name" />
      </div>
      <div className="grid gap-4 sm:grid-cols-2">
        <TextField label="Business Email" name="email" type="email" required value={form.email} onChange={set} testId="staffing-email" />
        <TextField label="Phone" name="phone" value={form.phone} onChange={set} testId="staffing-phone" />
      </div>
      <div className="grid gap-4 sm:grid-cols-2">
        <SelectField label="Engagement Type" name="engagement_type" value={form.engagement_type} onChange={set} options={ENGAGEMENTS} testId="staffing-engagement" />
        <SelectField label="Industry" name="industry" value={form.industry} onChange={set} options={INDUSTRIES} testId="staffing-industry" />
      </div>
      <TextField label="Roles Needed" name="roles_needed" placeholder="e.g. 3 Embedded Engineers, 1 Data Engineer" value={form.roles_needed} onChange={set} testId="staffing-roles" />
      <TextArea label="Details" name="details" placeholder="Timeline, location, skills, seniority..." value={form.details} onChange={set} testId="staffing-details" />
      <button
        type="submit"
        disabled={loading}
        className="group inline-flex w-full items-center justify-center gap-2 rounded-full bg-sky-400 px-6 py-3.5 text-sm font-medium text-ink-900 transition-colors hover:bg-sky-300 disabled:opacity-60"
        data-testid="staffing-submit"
      >
        {loading ? "Submitting..." : "Submit Requirement"}
      </button>
    </form>
  );
}

export default StaffingForm;
